module.exports = __webpack_public_path__ + "static/media/bgm.af7dcdb6.mp3";